var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacturasRecibidas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6802 19.7852V5.28516C20.6802 4.75472 20.4786 4.24602 20.1199 3.87094C19.7611 3.49587 19.2744 3.28516 18.767 3.28516H7.86197C7.70975 3.28516 7.56376 3.34837 7.45612 3.46089C7.34849 3.57341 7.28802 3.72603 7.28802 3.88516V21.2852H19.2453M16.8539 7.28516H11.1144M19.2453 15.2852H7.28802M19.2453 18.2852H7.28802",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28802 11.3291H2.00447M2.00447 11.3291L5.00447 8.3291M2.00447 11.3291L5.00447 14.3291",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1802 15.2852C20.1802 15.2852 20.6802 15.9572 20.6802 16.7852C20.6802 17.6132 20.1802 18.2852 19.1802 18.2852C20.1802 18.2852 20.6802 18.9572 20.6802 19.7852C20.6802 20.6132 20.1802 21.2852 19.1802 21.2852",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacturasRecibidas);
export default __webpack_public_path__ + "static/media/facturas_recibidas.e42579e0ba0c09f452f0ad2ea0a4b1c7.svg";
export { ForwardRef as ReactComponent };